// extracted by mini-css-extract-plugin
module.exports = {"time":"timestamp-m__time__2whrh","bottom-fix":"timestamp-m__bottom-fix__2nzP3","dark":"timestamp-m__dark__1mr8m","light":"timestamp-m__light__2iA9x"};